<template>
  <pt-report-unscramble-table class="pt-report-unscramble-table__withData" ref="table" :request-data="getDataList" :page-size="pageSize"
  :total-number="Number(totalNumber)" :table-data="tableData" :tableLabels="tableLabels" :status="status">
    <template slot-scope="scope">
      <slot :row="scope.row"></slot>
    </template>
  </pt-report-unscramble-table>
</template>

<script>
import PtReportUnscrambleTable from './index'
export default {
  name: 'pt-report-unscramble-table__withData',
  components: {
    'pt-report-unscramble-table': PtReportUnscrambleTable
  },
  data () {
    return {
      pageSize: 10,
      totalNumber: 0,
      tableData: []
    }
  },
  props: {
    status: {
      type: String,
      required: true
    },
    tableLabels: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    status (val, old) {
      this.$refs.table.reload()
    }
  },
  methods: {
    getDataList (page, next) {
      let data = {
        example: { status: this.status },
        pageable: { page: page, size: this.pageSize, sort: ['createdDate,asc'] }
      }
      // this.buildFilterParams(page, this.currentParams)
      this.$store.dispatch('orderHandleList', data).then(res => {
        next(res.data)
        this.tableData = res.data
        this.totalNumber = res.totalNumber
        this.$emit('getAllSize', this.totalNumber)
      }).catch(err => {
        this.$refs.table.showReTry()
        this.$message.error(err)
      })
    }
  }
}
</script>
